/**
 * Estado compartilhado da pré-carga STATISTICS (lista ecommerce).
 * Detalhe lê isto para saber se docs já vieram do batch.
 * @module ecommerceResourcesPreloadStatus
 */

export type EcommerceResourcesPreloadStatus =
  | "idle"
  | "loading"
  | "success"
  | "failed";

let status: EcommerceResourcesPreloadStatus = "idle";
const listeners = new Set<() => void>();

function notify(): void {
  listeners.forEach((listener) => listener());
}

export function getEcommerceResourcesPreloadStatus(): EcommerceResourcesPreloadStatus {
  return status;
}

/** true só após pré-carga de docs concluir com sucesso. */
export function wasEcommerceDocsPreloadSuccessful(): boolean {
  return status === "success";
}

export function setEcommerceResourcesPreloadStatus(
  next: EcommerceResourcesPreloadStatus,
): void {
  if (status === next) return;
  status = next;
  notify();
}

export function subscribeEcommerceResourcesPreloadStatus(
  listener: () => void,
): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
